/*
 * @Description: 
 * @Author: 李方强
 * @Date: 2019-12-06 09:53:45
 * @LastEditTime: 2021-02-08 14:28:53
 * @LastEditors: lkz
 */

/**
 * import中的webpackChunkName，为按需加载生成的JS名称，请使用 [project-name]-[module-name]，示例如下
 */
export default [
  {
    path: '/monitor/monitor',
    name:'/monitor/monitor',
    meta:{
        title:'心云监控'
    },
    component: () =>
        import ( /* webpackChunkName: "example-monitor" */ '../views/monitor/monitor.vue')
  },
  {
    path: '/monitor/skillMonitor',
    name:'/monitor/skillMonitor',
    meta:{
        title:'技能组监控'
    },
    component: () =>
        import ( /* webpackChunkName: "example-monitor" */ '../views/monitor/skillMonitor.vue')
  },
  {
    path: '/monitor/seatMonitor',
    name:'/monitor/seatMonitor',
    meta:{
        title:'坐席监控'
    },
    component: () =>
        import ( /* webpackChunkName: "example-monitor" */ '../views/monitor/seatMonitor.vue')
  },
  {
    path: '/monitor/workMonitor',
    name:'/monitor/workMonitor',
    meta:{
        title:'工单监控'
    },
    component: () =>
        import ( /* webpackChunkName: "example-monitor" */ '../views/monitor/workMonitor.vue')
  },
  {
    path: '/monitor/taskMonitor',
    name:'/monitor/taskMonitor',
    meta:{
        title:'任务监控'
    },
    component: () =>
        import ( /* webpackChunkName: "example-monitor" */ '../views/monitor/taskMonitor.vue')
  },
  {
    path: '/monitor/clueBoard',
    name: '/monitor/clueBoard',
    meta: {
        title: '线索看板'
    },
    component: () =>
        import ( /* webpackChunkName: "example-monitor" */ '../views/monitor/clueBoard.vue')
  },
  {
    path: '/monitor/clueBoardDetail',
    name: '/monitor/clueBoardDetail',
    meta: {
        title: '线索详情看板'
    },
    component: () =>
        import ( /* webpackChunkName: "example-monitor" */ '../views/monitor/clueBoardDetail.vue')
  },
  {
    path: '/monitor/serviceSubtotalBoard',
    name: '/monitor/serviceSubtotalBoard',
    meta: {
        title: '服务小记看板'
    },
    component: () =>
        import ( /* webpackChunkName: "example-monitor" */ '../views/monitor/serviceSubtotalBoard.vue')
  },
  {
    path: '/monitor/serviceSubtotalBoardDetail',
    name: '/monitor/serviceSubtotalBoardDetail',
    meta: {
        title: '服务小记详情看板'
    },
    component: () =>
        import ( /* webpackChunkName: "example-monitor" */ '../views/monitor/serviceSubtotalBoardDetail.vue')
  }
]
